import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Language, LanguageService } from '../../services/language.service';
import { MaterialModule } from '../../shared/material.module';

@Component({
  selector: 'app-language-selector',
  imports: [
    CommonModule,
    MaterialModule
  ],
  templateUrl: './language-selector.html',
  styleUrl: './language-selector.scss'
})
export class LanguageSelectorComponent {
  languages: Language[];
  currentLanguage: Language;

  constructor(private languageService: LanguageService) {
    this.languages = this.languageService.getLanguages();
    this.currentLanguage = this.languageService.getCurrentLanguage();

    this.languageService.getCurrentLanguage$().subscribe(language => {
      this.currentLanguage = language;
    });
  }

  selectLanguage(language: Language): void {
    this.languageService.setLanguage(language);
    this.currentLanguage = language;
  }
}